import React, { useEffect, useState } from "react";
import "./navheader.scss";
import Container from "react-bootstrap/Container";
import Logo from "../Logo/logo";

const NavHeader = () => {
    const [isNavbarScrolled, setIsNavbarScrolled] = useState(false); // State to toggle navbar class
    const [activeSection, setActiveSection] = useState("backToTop"); // State to track the active section

    useEffect(() => {
        const handleScroll = () => {
            // Toggle class for navbar
            if (window.scrollY > 360) {
                setIsNavbarScrolled(true);
            } else {
                setIsNavbarScrolled(false);
            }

            // Custom ScrollSpy logic
            const sections = document.querySelectorAll("section");
            let currentSection = "backToTop"; // Default section

            sections.forEach((section) => {
                const sectionTop = section.getBoundingClientRect().top + window.scrollY - 20; // Adjust offset
                if (window.scrollY >= sectionTop) {
                    currentSection = section.getAttribute("id") || "backToTop";
                }
            });

            setActiveSection(currentSection);
        };

        // Attach scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const toggleBodyClass = () => {
        // Toggle a class on the <body> element
        document.body.classList.toggle("nav-open");

        // Scroll the page to the top
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const closeNav = () => {
        // Remove the 'nav-open' class from the <body> element
        document.body.classList.remove("nav-open");
    };

    const fun = (e) => {
        e.preventDefault();
        const bodyElement = document.querySelector("body");
        if (bodyElement) {
            bodyElement.classList.toggle("toggleTrue");
        }
    };

    return (
        <>
            <header id="backToTop">
                <Container fluid>
                    <Container className="d-flex">
                        <a
                            href="#"
                            onClick={fun}
                            className="navbar-brand logo"
                            id="logo"
                            title="Animate Web Design of Boston logo"
                        >
                           <Logo />
                        </a>
                        <button
                            className="navbar-toggler border-0 ms-auto"
                            type="button"
                            aria-label="Toggle navigation"
                            onClick={toggleBodyClass}
                        >
                            <div className="navMenu-icon">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </Container>
                </Container>
            </header>
            <Container fluid className="banner" role="complementary">
                <div className="WDB d-none d-lg-block">Web Design of Boston</div>
                <h1>Expert Web Design &amp; Development</h1>
            </Container>
            <nav
                className={
                    isNavbarScrolled
                        ? "navbar navbar-expand-lg fixedNavbar"
                        : "navbar navbar-expand-lg"
                }
                aria-label="Main navigation"
            >
                <Container fluid>
                    <Container>
                        <div className="navbar-collapse offcanvas-collapse">
                            <ul
                                className="navbar-nav me-auto mb-lg-0 mt-lg-0 container"
                                id="navbar"
                            >
                                <li className={"nav-item"}>
                                    <a
                                        className={`nav-link ${
                                            activeSection === "backToTop"
                                                ? "active"
                                                : ""
                                        }`}
                                        href="#backToTop"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            closeNav();
                                            document
                                                .getElementById("backToTop")
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        Home
                                    </a>
                                </li>
                                <li className={"nav-item"}>
                                    <a
                                        className={`nav-link ${
                                            activeSection === "featured"
                                                ? "active"
                                                : ""
                                        }`}
                                        href="#featured"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            closeNav();
                                            document
                                                .getElementById("featured")
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        Featured work
                                    </a>
                                </li>
                                <li className={"nav-item"}>
                                    <a
                                        className={`nav-link ${
                                            activeSection === "testimonials"
                                                ? "active"
                                                : ""
                                        }`}
                                        href="#testimonials"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            closeNav();
                                            document
                                                .getElementById("testimonials")
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        Testimonials
                                    </a>
                                </li>
                                <li className={"nav-item"}>
                                    <a
                                        className={`nav-link ${
                                            activeSection === "portfolio"
                                                ? "active"
                                                : ""
                                        }`}
                                        href="#portfolio"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            closeNav();
                                            document
                                                .getElementById("portfolio")
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        Portfolio
                                    </a>
                                </li>
                                <li className={"nav-item"}>
                                    <a
                                        className={`nav-link ${
                                            activeSection === "about"
                                                ? "active"
                                                : ""
                                        }`}
                                        href="#about"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            closeNav();
                                            document
                                                .getElementById("about")
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        About
                                    </a>
                                </li>
                                <li className={"nav-item"}>
                                    <a
                                        className={`nav-link ${
                                            activeSection === "contact"
                                                ? "active"
                                                : ""
                                        }`}
                                        href="#contact"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            closeNav();
                                            document
                                                .getElementById("contact")
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        Contact
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </Container>
                </Container>
            </nav>
        </>
    );
};

export default NavHeader;
